/**
 * Material Design Icons, inline.
 *
 * The design system specifies MDI, but a webfont from a CDN is the wrong way to
 * get it: it is a third-party request on every page load, it fails closed on a
 * restricted network, and it ships thousands of glyphs to draw a dozen. `@mdi/js`
 * is path data that tree-shakes to the icons actually referenced.
 *
 * Always decorative. Every control that carries an icon also carries a text
 * label or an accessible name, so the icon is hidden from assistive technology
 * rather than duplicating what is already announced.
 */
export function Icon({
  path,
  size = 18,
  className,
}: {
  path: string;
  size?: number;
  className?: string;
}) {
  return (
    <svg
      aria-hidden="true"
      className={`shrink-0 ${className ?? ""}`}
      focusable="false"
      height={size}
      viewBox="0 0 24 24"
      width={size}
    >
      <path d={path} fill="currentColor" />
    </svg>
  );
}
